<template>
    <div class="message-viewer">
        <Message
            :id="`sc-message_${$_.get(message, 'id') || $_.get(message, 'raw.uniqMessageId')}`"
            key="TEST"
            :colors="colors"
            :is-chat-window="false"
            :is-colored="false"
            :message="message"
            :random-bg-color-with-name="false"
            :showAvatar="false"
            :user="profile(message)"
            @remove="$emit('remove', message)"
            :disable-translation="true"
            :is-whatsapp="false"
            :channel-id="null"
            :reply-mode="true"
            :override-style="{ 'max-width': 'unset !important' }"
        >
            <template v-slot:user-avatar="scopedProps">
                <slot :message="scopedProps.message" :user="scopedProps.user" name="user-avatar"></slot>
            </template>
            <template v-slot:text-message-body="scopedProps">
                <slot
                    :me="scopedProps.me"
                    :message="scopedProps.message"
                    :messageColors="scopedProps.messageColors"
                    :messageText="scopedProps.messageText"
                    name="text-message-body"
                >
                </slot>
            </template>
            <template v-slot:text-message-toolbox="scopedProps">
                <slot :me="scopedProps.me" :message="scopedProps.message" name="text-message-toolbox"></slot>
            </template>
        </Message>
        <IconButton :on-click="remove"><span class="material-icons"> close </span></IconButton>
    </div>
</template>
<script>
import Vue from "vue";
import Message from "./Message.vue";
import IconButton from "../../views/Pages/Settings/components/IconButton.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    name: "MessageViewer",
    components: { IconButton, Message },
    props: ["message", "colors"],
    methods: {
        ...mapActions({
            unpinReplyToMessage: "chat/unpinReplyToMessage",
        }),
        profile(message) {
            return { _id: message.raw?.user?._id || message.raw?.userId, name: message.author };
        },
        remove() {
            const conversationId = this.message.raw?.conversationId || this.message.raw?.conversation;
            this.unpinReplyToMessage(conversationId);
        },
    },
});
</script>

<style scoped lang="scss">
.message-viewer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .sc-message--text {
        max-width: unset !important;
    }
}
</style>
